import { createTheme } from '@mui/material/styles';

const colors = {
	secondary: {
		main: 'rgba(0, 206, 124, 1)',
	},
	success: {
		main: 'rgba(0, 206, 124, 1)',
	},
	error: {
		main: 'rgba(255, 71, 87,1.0)',
		dark: 'rgba(255, 71, 87,1.0)',
	},
};

const commonProps = {
	shape: {
		borderRadius: 8,
	},
	typography: {
		fontFamily: 'Roboto',
		h4: {
			fontWeight: 800,
		},
	},
	components: {
		MuiButtonGroup: {
			defaultProps: {
				disableElevation: true,
			},
		},
		MuiButton: {
			defaultProps: {
				disableElevation: true,
			},
		},
	},
};

export const lightTheme = createTheme({
	palette: {
		mode: 'light',
		primary: {
			main: 'rgba(16, 24, 32, 1)',
		},
		...colors,
	},
	...commonProps,
});

export const darkTheme = createTheme({
	palette: {
		mode: 'dark',
		primary: {
			main: 'rgba(255, 255, 255, 1)',
		},
		background: {
			default: 'rgba(16, 24, 32, 1)',
			paper: 'rgba(16, 24, 32, 1)',
		},
		...colors,
	},
	...commonProps,
});

export const appTheme = createTheme({
	palette: {
		mode: 'light',
		primary: {
			main: 'rgba(16, 24, 32, 1)',
		},
		...colors,
	},
	...commonProps,
});

export const muiExitTheme = createTheme({
	...commonProps,
	palette: {
		mode: 'light',
		primary: {
			main: 'rgba(16, 24, 32, 1)',
		},
		...colors,
	},
});
